import React from 'react';
import { SVGProps } from 'react';

const SVGScale = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.33342 2H7.66675V3.39023C7.32088 3.5125 7.06235 3.81963 7.00988 4.1929L4.58038 4.84473C4.50515 4.8649 4.43935 4.9108 4.39445 4.97443L2.4428 7.73927H2.04004C2.04004 7.96947 2.06739 8.19283 2.1188 8.40593C2.12906 8.44847 2.14028 8.49057 2.15244 8.53223C2.46896 9.61777 3.41822 10.4059 4.54005 10.4059C5.70495 10.4059 6.68382 9.55587 6.96135 8.4057C7.01265 8.193 7.03995 7.97 7.04005 7.74023V7.73927H6.72842L5.19535 5.36997L7.14228 4.84763C7.26105 5.04523 7.44612 5.19843 7.66675 5.27643V12.6667H6.66675V13.3333H4.66675V14H11.3334V13.3333H9.33342V12.6667H8.33342V5.27643C8.71712 5.1408 8.99332 4.7777 8.99998 4.34913L10.7131 3.88957L9.49142 5.66667H9.00008C9.00008 5.8968 9.02742 6.1201 9.07878 6.3331C9.35632 7.48327 10.3352 8.33333 11.5001 8.33333C12.6219 8.33333 13.5712 7.54517 13.8877 6.45967C13.8998 6.41797 13.9111 6.37587 13.9213 6.33333C13.9676 6.14157 13.9944 5.94143 13.9993 5.7355C13.9998 5.71293 14.0001 5.69033 14.0001 5.66763V5.66667H13.3515L11.7867 3.16304C11.7156 3.04321 11.5743 2.97765 11.433 3.00681C11.4265 3.00814 11.4201 3.00966 11.4137 3.01139L8.78695 3.71613C8.67088 3.56833 8.51405 3.45407 8.33342 3.39023V2ZM10.3004 5.66667H12.5653L11.4868 3.94103L10.3004 5.66667ZM5.93435 7.73927L4.65475 5.7617L3.25883 7.73927H5.93435Z"
      fill={props.fill ?? '#D6545E'}
    />
  </svg>
);

export default SVGScale;
